import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Select from 'react-select';
import { NumericFormat } from "react-number-format";

const ClientContract = ({ contract, setContract, handleAdd }) => {
   // const [show, setShow] = useState('');
    const [sales, setSales] = useState([]);
   // const [cart, setCart] = useState([]);
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [pages, setPages] = useState(0);
    const [rows, setRows] = useState(0);
    const [msg, setMsg] = useState("");
    const [error, setError] = useState(null);
    const [keywordcust, setKeywordCust] = useState("");
    const [querycust, setQueryCust] = useState("");
    const [selectcustomer, setSelectCustomer] = useState(null);
    const [optioncust, setOptionCust] = useState([]);
    const { productId} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        const fetchContracts = async () => {
            try {
                const productId = contract.id;
                const res = await axios.get(
                    `${API_BASE_URL}/productitemcontract/${productId}?search_customer=${keywordcust}&page=${page}&limit=${limit}`,{
                        headers: {
                            'X-API-Key': API_KEY
                        },
                    }
                );
                setSales(res.data.response);
                setPage(res.data.page);
                setPages(res.data.totalPage);
                setRows(res.data.totalRows);
                //console.log(res.data);
            } catch (error) {
                if (error.response) {
                    setMsg(error.response.data.msg);
                }
            }
        };

        const fetchOptionCust = async () => {
            setIsLoading(true);
            try {
                // Replace with your actual Node.js API endpoint
                const resultcust = await axios.get(`${API_BASE_URL}/client`, {
                    headers: {
                        'X-API-Key': API_KEY
                    },
                }); 
                const datacust = resultcust.data;

                // Map the API data to the format react-select expects: { value: '', label: '' }
                const formattedOptionCust = datacust.map(item => ({
                value: item.id,
                label: item.name,
                }));

                setOptionCust(formattedOptionCust);
                setError(null);
            } catch (err) {
                setError('Failed to load options');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchContracts();
        fetchOptionCust();
}, [productId, page, keywordcust]);

const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setQueryCust("");
      setSelectCustomer(null);
      setKeywordCust("");
      return; // Exit the function gracefully
    }
    const newValue = selectedOption;
    setQueryCust(newValue.value);
    setSelectCustomer(newValue);
    console.log('Option selected:', newValue);
  };

const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordCust(querycust);
};

const calculateDaysDifference = (endDate) => {
    const start = new Date();
    const end = new Date(endDate);
    const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
    const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
    if(daysDifference < 0){
      return <span className="tag is-danger">Expired</span>;
    }else{
      return <span className="tag is-success">Guarantee</span>;
    }  
};

const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
      setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
      );
    } else {
      setMsg("");
    }
  };

  return (
    <div className="container">
        <div className="columns">
            <div className="column is-centered">
                <h1 className="title has-text-centered is-size-5">CLIENT/CUSTOMER CONTARCT</h1>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className="columns">
                    <div className="column is-9">
                        <form onSubmit={searchData}>
                            <div className="columns">
                                <div className="column is-8">
                                    <div className="control">
                                        <Select
                                            value={selectcustomer}
                                            onChange={handleCustomerChange}
                                            options={optioncust}
                                            isLoading={isLoading}
                                            isClearable={true} 
                                            placeholder="Filter by customer..."
                                        />
                                    </div>
                                </div>
                                <div className="column is-1">
                                    <div className="control">
                                        <button type="submit" className="button is-small is-info">
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="card is-shadowless">
                    <table className="table is-bordered is-striped is-fullwidth is-size-7">
                        <thead>
                            <tr>
                                <th style={{width: "1%"}}>No</th>
                                <th className="has-text-centered" style={{width: "5%"}}>Contract_No</th>
                                <th className="has-text-centered">Client/Customer</th>
                                <th className="has-text-centered">Address</th>
                                <th className="has-text-centered">Phone</th> 
                                <th className="has-text-centered">Product</th>
                                <th className="has-text-centered">Qty</th>                              
                                <th className="has-text-centered">End_Guarantee</th>
                                <th className="has-text-centered">Status_Guarantee</th>
                                <th className="has-text-centered">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sales.map((item, index) => (
                                <tr key={item.uuid}>
                                    <td>{index + 1}</td>
                                    <td className="has-text-centered">{item.contract.contract_no}</td>
                                    <td>{item.contract.client.name}</td>
                                    <td>{item.contract.client.address}</td>               
                                    <td>{item.contract.client.phone}</td>  
                                    <td>{item.product.name}</td> 
                                    <td className="has-text-centered">
                                    <NumericFormat
                                    value={item.qty}
                                    displayType="text" // Renders as a <span> instead of an input
                                    thousandSeparator={true}
                                    decimalScale={0}
                                    fixedDecimalScale={true} /></td>                                   
                                    <td className="has-text-centered">
                                        {new Date(item.contract.end_guarantee).toLocaleDateString('id', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        })}
                                       
                                    </td>
                                    <td className="has-text-centered">{calculateDaysDifference(item.contract.end_guarantee)}</td>
                                    <td className="has-text-centered">
                                        <button className="button is-small is-link" onClick={() => handleAdd(contract, item.contract.clientId, item.contract.end_guarantee)}>Add to Ticket</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>  
                    <p className="is-size-7">
                    Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
                    </p>
                    <p className="has-text-centered has-text-danger">{msg}</p>
                    <nav
                    className="pagination is-centered is-size-7"
                    key={rows}
                    role="navigation"
                    aria-label="pagination"
                    >
                    <ReactPaginate
                        breakLabel="..."
                        previousLabel={"< Prev"}
                        nextLabel={"Next >"}
                        pageCount={Math.min(10, pages)}
                        onPageChange={changePage}
                        containerClassName={"pagination-list"}
                        pageLinkClassName={"pagination-link"}
                        previousLinkClassName={"pagination-previous"}
                        nextLinkClassName={"pagination-next"}
                        activeLinkClassName={"pagination-link is-current"}
                        disabledLinkClassName={"pagination-link is-disabled"} />
                    </nav>
                </div>
            </div>
        </div>
    </div>
  );
};

export default ClientContract;